export const externalPageNames = {
  mapPreview: 'google_map_preview',
  mapNavi: 'google_map_navi',
} as const;
